import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NewsletterModal from './components/NewsletterModal';

// Custom Hook
import useNewsletterModal from './hooks/useNewsletterModal';

// Page Components
import HomePage from './pages/HomePage';
import ComingSoonPage from './pages/ComingSoonPage';
import AboutPage from './pages/AboutPage';
import MissionPage from './pages/MissionPage';
import AchievementsPage from './pages/AchievementsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import MediaPage from './pages/MediaPage';
import EventsPage from './pages/EventsPage';
import DonationPage from './pages/DonationPage';
import DonationSuccessPage from './pages/DonationSuccessPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const { isModalOpen, openModal, closeModal } = useNewsletterModal();

  return (
    <div className="flex flex-col min-h-screen"> {/* Updated to Tailwind classes */}
      <Navbar />
      <main className="flex-grow pt-5 pb-5"> {/* Updated to Tailwind classes */}
        <Routes>
          <Route path="/" element={<HomePage onNewsletterClick={openModal} />} />

          {/* Routes to be shown as Coming Soon */}
          <Route path="/about" element={<AboutPage onNewsletterClick={openModal} />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/achievements" element={<AchievementsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/donate" element={<DonationPage />} />
          <Route path="/donation-success" element={<DonationSuccessPage />} />

          <Route path="*" element={<NotFoundPage />} /> {/* Catch-all for 404 */}
        </Routes>
      </main>
      <Footer onNewsletterClick={openModal} />

      {/* Newsletter Modal */}
      <NewsletterModal
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </div>
  );
}

export default App;
